var _tspan, _tspan2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverGreenEngine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    width: "800px",
    height: "800px",
    viewBox: "0 0 89.938 89.938",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M88.461,37.406h-1.969c-0.814,0-1.479,0.663-1.479,1.477v25.655c0,0.814,0.662,1.479,1.479,1.479h1.969 c0.813,0,1.477-0.664,1.477-1.479V38.882C89.938,38.069,89.275,37.406,88.461,37.406z",
    style: {
      fill: "rgb(22, 163, 74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.477,36.157C0.664,36.157,0,36.819,0,37.634v28.164c0,0.813,0.663,1.478,1.477,1.478h4.015 c0.814,0,1.477-0.663,1.477-1.478V37.642c0-0.813-0.662-1.477-1.477-1.477H1.477V36.157z",
    style: {
      fill: "rgb(22, 163, 74)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.617,71.781c3.294-1.278,6.568-2.595,9.855-3.872c0.293-0.113,0.634-0.152,0.947-0.16 c2.432-0.01,4.864-0.01,7.288-0.01c2.519,0,4.138-1.62,4.138-4.166v-8.331c0-0.597,0.481-1.069,1.069-1.069l1.05-0.027 c0.834,0,0.883-0.323,0.909-0.9l0.021-4.837c0-0.481-0.389-0.871-0.872-0.871h-1.126c-0.598,0-1.079-0.483-1.079-1.08 l0.036-10.101c0.029-1.496-0.576-2.527-1.723-3.352c-1.969-1.42-7.771-5.538-8.719-6.144c-0.652-0.427-1.363-0.597-2.158-0.587 l-10.007-0.01c-0.853,0-1.543-0.691-1.543-1.543v-0.312c0-0.861,0.7-1.562,1.562-1.562h9.07c0.86,0,1.562-0.7,1.562-1.562v-1.809 c0-0.861-0.701-1.562-1.562-1.562H36.222c-0.862,0-1.562,0.7-1.562,1.562v1.809c0,0.861,0.7,1.562,1.562,1.562h9.816 c0.862,0,1.563,0.701,1.563,1.562v0.36c0,0.852-0.691,1.552-1.555,1.542l-9.911-0.037c-1.895-0.057-3.446,0.587-4.886,1.628 c-2.102,1.524-4.165,3.096-6.229,4.668c-0.521,0.397-1.174,0.615-1.827,0.605c-1.987-0.02-3.976-0.02-5.964,0 c-2.471,0.019-4.07,1.609-4.09,4.09l0.028,6.901c0,0.586-0.474,1.069-1.07,1.069h-0.927c-1.127,0-2.036,0.909-2.036,2.036v10.935 c0,1.126,0.909,2.034,2.036,2.034h0.899c0.587,0,1.069,0.475,1.069,1.07c0,1.57-0.01,4.496,0,6.189 c0,1.573-0.028,4.526,2.85,4.526h40.37C56.784,72.027,57.229,71.942,57.617,71.781z",
    style: {
      fill: "rgb(22, 163, 74)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fontFamily: "Arial, sans-serif",
      fontSize: 3,
      fontWeight: 700,
      paintOrder: "fill",
      strokeWidth: "1.43975px",
      whiteSpace: "pre"
    },
    transform: "matrix(19.776464, 0, 0, 16.341, -728.503845, -592.270386)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 38.175,
    y: 40.332
  }, "D")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 38.175,
    dy: "1em"
  }, "\u200B"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverGreenEngine);
export default __webpack_public_path__ + "static/media/driver-green-engine.c44694b2cf8aa808a89006279a5b7e23.svg";
export { ForwardRef as ReactComponent };